import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import ConfirmBooking from "./ConfirmBooking";
import DetailsPreview from "./DetailsPreview";
import UserDetails from "./UserDetails";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ["User details", "Details preview", "Success"]; //........to display names at top of form like which form we are currently at.........

export default function Registration() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0); //...................maintains rendering of other child components.................
  {
    /*...................................................................|...............
      ............get from values from UserDetails.jsx user login.......\|/..............
      ...................................................................V...............*/
  }
  const [formValues, setFormValues] = React.useState({});
  {
    /*...................................................................................|...............
      ............get from values after preview from DetailsPreview.jsx user login......\|/..............
      ...................................................................................V...............*/
  }
  const [formValuesAfterPreview, setFormValuesAfterPreview] = React.useState(
    {}
  );

  const getStepContent = (Step) => {
    switch (Step) {
      case 0:
        return (
          <UserDetails
            getFormValues={setFormValues}
            triggerParentMethod={handleNext}
          />
        );
      case 1:
        return (
          <DetailsPreview
            values={formValues}
            getFormValuesAfterPreview={setFormValuesAfterPreview}
            triggerParentMethod={handleNext}
            triggerBackParentMethod={handleBack}
          />
        );
      case 2:
        return <ConfirmBooking values={formValuesAfterPreview} />;
      default:
        throw new Error("Unknown step");
    }
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center">
            Event Registration Form
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {/*.................................................................|...............
             ............trigger between different registration forms........\|/..............
            ..................................................................V...............*/}
          <React.Fragment>
            {activeStep === steps.length ? (
              <div></div>
            ) : (
              <React.Fragment>
                {getStepContent(activeStep)}
                <div className={classes.buttons}></div>
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
      </main>
    </React.Fragment>
  );
}
